import { Box, Chip, Typography } from '@mui/material';
import LogbookActions from '../components/LogbookListActions';
import { Logbook } from '../types/listTypes';

export const columns = (
  currentQueryKey: any,
  prefetchLogbookDetails?: (row: Logbook) => void
) => [
    {
      field: 'name',
      headerName: 'Logbook Details',
      align: 'left' as const,
      width: '60%',
      renderCell: (value: string, row: Logbook) => (
        <Box>
          <Typography variant="body1" fontWeight="bold" sx={{ marginBottom: '2px' }}>
            {row.logbookTemplateName || 'No Name'}
          </Typography>
          <Typography variant="body2" >
            {row.logbookTemplateDescription}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'type',
      headerName: 'Type',
      align: 'center',
      renderCell: (value: string, row: Logbook) => {
        const chipColor = value === 'Logbook' ? 'primary' : 'success';
        return (
          <Chip
            label={row.type.label}
            color={chipColor}
            variant="outlined"
          />
        );
      },
    },
    {
      field: 'action',
      headerName: 'Actions',
      align: 'center',
      renderCell: (value: string, row: Logbook) => {
        return (
          <LogbookActions
            row={row}
            queryKey={currentQueryKey}
            onEditHover={prefetchLogbookDetails}
          />
        );
      },
    },
  ];